import type { FormFieldProps } from "@octopusdeploy/design-system-octopus-components";
import type { TagSetResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import type { DoBusyTask } from "~/components/DataBaseComponent/DataBaseComponent";
import * as tagSets from "~/components/tagSets";
import { TagMultiSelect } from "./TagMultiSelect";
interface TenantTagMultiSelectionProps extends FormFieldProps<string[]> {
    doBusyTask: DoBusyTask;
    items?: TagSetResource[] | (() => TagSetResource[]);
    autoFocus?: boolean;
    disableCloseOnSelected?: boolean;
}
export class TenantTagMultiSelect extends React.Component<TenantTagMultiSelectionProps> {
    render() {
        return <TagMultiSelect {...this.props} getAll={() => tagSets.getAllByScopes(["Tenant"])} groupByTagSet={tagSets.groupByTagSet} flattenGroup={tagSets.flattenGroup}/>;
    }
    static displayName = "TenantTagMultiSelect";
}
